
const buttonStyles = {
  buttonStyle: {
    fontWeight:"bold", 
    borderRadius:" 3rem",
    position: "static"
  }
}

export default buttonStyles;
